<template lang="pug">
    v-container
        v-toolbar(card='' dark='' :color='colors.danger' )
            v-toolbar-title.white--text CIERRE DE CAJA
        v-card.pa-10
            v-layout.pa-2(row wrap)
                information-close
            v-layout.pa-2(row wrap)
                v-spacer
                v-flex(xs12 md6 class="text-xs-right" align-end)
                    modal-supervisor(
                            :available="showModal" 
                            title="CIERRE DE CAJA"  
                            @check-key="authorizeCloseCash()"
                            confirmMessage="Autorizar cierre de caja")
</template>

<script>
import InformationClose from '@/views/CloseCash/InformationClose.vue'
import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'
import cashDeskMustCloseCashGuard from '@/mixins/cashDeskMustCloseCashGuard'
import {
    responseCustomerFormat,
    responseEmployeeFormat,
    responseEgressTotal,
    customerTotalResponse,
    employeeTotalResponse,
} from '@/services/API/paymentSummaries/formatData'

import { mapActions, mapState } from 'vuex'
export default {
    name: 'close-cash',
    props: {},
    data: function() {
        return {}
    },
    computed: {
        ...mapState('CloseCashModule', {
            cashAmount: 'cashAmount',
        }),
        ...mapState('UniqueKeyModule', {
            uniqueKey: 'uniqueKey',
        }),
        ...mapState('AuthModule', {
            cash_desk_id: 'cash_desk_id',
        }),

        showModal() {
            return (
                this.cashAmount != '' &&
                this.cashAmount != null &&
                parseInt(this.cashAmount) % 10 === 0
            )
        },
    },
    methods: {
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            resetStateUniqueKeyModule: 'resetState',
            setUniqueKey: 'setUniqueKey',
            setPermission: 'setPermission',
        }),

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
        }),

        ...mapActions('CloseCashModule', {
            closeCash: 'closeCash',
            printReceip: 'printReceip',
            setInitialSummaries: 'setInitialSummaries',
            setArqueoData: 'setArqueoData',
            resetStateCloseCashModule: 'resetState',
            fetchDailyInvoices: 'fetchDailyInvoices',
            setInvoicesData: 'setInvoicesData',
        }),

        ...mapActions('PaymentSummariesModule', {
            getPaymentSummaries: 'getPaymentSummaries',
            fetchInitialResume: 'fetchInitialResume',
            setTotalIncome: 'setTotalIncome',
        }),
        ...mapActions('AuthModule', [
            'setOpenCashDesk',
            'setMustCloseCashDesk',
        ]),

        formatObjects: function(object, formatter) {
            let obj = JSON.parse(JSON.stringify(object))
            formatter.forEach(format => {
                obj[format.front] = obj[format.back]
                delete obj[format.back]
            })
            return obj
        },

        async authorizeCloseCash() {
            let payload = this.fillSnack(
                'info',
                'Confirmando',
                'Confirmando datos Supervisor',
                true
            )
            this.initSnackbar(payload)
            let response = await this.authorize()
            //let response = {status: 'success'}
            if (response.status === 'success') {
                const fullName = ({ names, last_name1 }) =>
                    `${names} ${last_name1}`
                let supervisor = {
                    name: fullName(response.user),
                    id: response.user.id,
                }
                let payloadSnack = this.fillSnack(
                    'info',
                    'Cierre de caja autorizado',
                    'Espere un momento',
                    true
                )
                this.initSnackbar(payloadSnack)

                let cashDesk = this.cash_desk_id

                // Invoices details since last cash opening:
                let invoiceDetails = await this.fetchDailyInvoices(cashDesk)

                this.setInvoicesData(invoiceDetails) // Aquí antes de subirlo debería corroborar que estado haya sido success y que data no esté vacía

                // Arqueo summaries:
                let responseSummaries = await this.getPaymentSummaries({
                    cashDesk: cashDesk,
                    authCode: this.uniqueKey,
                })

                if (responseSummaries.status === 'success') {
                    let customer = this.formatObjects(
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.customer_sales_total_detail,
                        responseCustomerFormat
                    )
                    let customerTotal =
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.customer_sales_total
                    let employeeTotal =
                            responseSummaries.data.resume_pos_daily_cash
                                .ingress_total_detail.employee_sales_total,
                        employeeTotalResponse
                    let employee = this.formatObjects(
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.employee_sales_total_detail,
                        responseEmployeeFormat
                    )
                    let egress = this.formatObjects(
                        responseSummaries.data.resume_pos_daily_cash
                            .egress_total_detail,
                        responseEgressTotal
                    )

                    let income =
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail
                    let initialAmountCash =
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.initial_amount_cash

                    let arqueoData = {
                        customer: customer,
                        customerTotal: customerTotal,
                        employeeTotal: employeeTotal,
                        employee: employee,
                        egress: egress,
                        income: income,
                    }

                    this.setArqueoData(arqueoData)

                    let payloadSnack = this.fillSnack(
                        'info',
                        'Registrando cierre de caja',
                        'Espere un momento',
                        true,
                        0
                    )
                    this.initSnackbar(payloadSnack)

                    await this.saveMovement(supervisor)
                    this.$router.push('/movement')
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error al generar Arqueo',
                        responseSummaries.statusText,
                        false,
                        2000
                    )
                    this.initSnackbar(payload)
                }
            } else {
                let payload = this.fillSnack(
                    'error',
                    'Error Codigo de autorización',
                    response.message,
                    false,
                    2000
                )
                this.initSnackbar(payload)
            }
        },

        async saveMovement(supervisor = null) {
            // Aquí llamar a "guardar cierre de caja" y luego llamar a "imprimir"
            let responseSaveMov = await this.closeCash(this.uniqueKey)

            if ((responseSaveMov.status = 'success')) {
                if (
                    responseSaveMov.http_status_code === 200 ||
                    responseSaveMov.http_status_code === 201
                ) {
                    let payload = {
                        typeMessage: 'info',
                        message: {
                            title: 'Imprimiendo Comprobante',
                            body: 'Espere...',
                        },
                        timeout: 6000,
                        showProgress: true,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)
                    this.resetStateUniqueKeyModule()
                    this.setOpenCashDesk(false)
                    this.setMustCloseCashDesk(false)

                    let id = responseSaveMov.data.pos_daily_cash.id
                    //let id = 987
                    let printed = await this.printReceip({
                        idMovCaja: id,
                        supervisor,
                    })

                    payload = {
                        typeMessage: 'success',
                        message: {
                            title: 'Éxito',
                            body: `Comprobante de cierre de caja impreso.`,
                        },
                        timeout: 6000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)

                    this.clearFormCloseCash()
                    this.$router.push('/movement')
                } else {
                    let payload = {
                        typeMessage: 'error',
                        message: {
                            title: 'ERROR',
                            body: responseSaveMov.error,
                        },
                        timeout: 6000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.setUniqueKey('')
                    this.initSnackbar(payload)
                }
            } else {
                // no se pudo guardar movimiento
                let payload = {
                    typeMessage: 'warning',
                    message: {
                        title: 'ERROR',
                        body: responseSaveMov.error,
                    },
                    timeout: 6000,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.setUniqueKey('')
                this.initSnackbar(payload)
            }
            this.showModal = false
        },

        clearFormCloseCash: function() {
            this.comment = ''
            this.cash = ''
            this.resetStateCloseCashModule()
            this.$emit('clearform')
        },
    },
    watch: {},
    components: { ModalSupervisor, InformationClose },
    mixins: [cashDeskMustCloseCashGuard],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: async function() {
        let cashDesk = this.cash_desk_id
        let initialSummaries = await this.fetchInitialResume(cashDesk)
        this.setInitialSummaries(initialSummaries.data.resume_pos_daily_cash)
    },
    mounted: function() {
        this.setPermission(this.mixAuthCodePermissions.EXECUTE_CLOSE_CASH_DESK)
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
